import type { ToUint16 } from "./types";

export const toUint16: ToUint16 = ({ value, min, max }) => {
  if (max === min) return 0;
  const normalized = (value - min) / (max - min);
  return Math.max(0, Math.min(65535, Math.round(normalized * 65535)));
};
